import { parseAsStringEnum, createLoader, parseAsString } from 'nuqs/server';

import { DEFAULT_SORT_OPTION, SortOptionEnum } from '@/fo/ui/article/list/base';

export const topicSearchParams = {
  sort: parseAsStringEnum(Object.values(SortOptionEnum)).withDefault(
    DEFAULT_SORT_OPTION
  ),
  query: parseAsString.withDefault('')
};

export const loadTopicSearchParams = createLoader(topicSearchParams);
